export enum SingleAgeReportTypes {
    Normal = 'normal',
    Aggregated = 'aggregated',
}
